import { plainToClass } from "class-transformer";
import { DataFrameContent } from "../models/BaseContent";
import { ResponseModel } from "../models/BaseResponse";
import ComputeApiService from "./compute_api_service";

export interface ReferenceData {
  symbol: string;
  stock_price: number[];
  market_cap: number;
}

class ReferenceAPIService {
  static async getReferenceInfo(start_date: string, end_date: string) {
    const input = `KRX:305720 KRX:364690 KRX:388420 KRX:433500 주가 시가총액 ${start_date}-${end_date}`;
    try {
      const res = await ComputeApiService.get({ input: input });
      const response = plainToClass(ResponseModel, res.data);
      const data = plainToClass(DataFrameContent, response.getData());

      // mapper
      const refData: { [symbol: string]: ReferenceData } = {};
      const stock_symbol_hash: { [key: string]: number[] } = {};
      const stock_market_hash: { [key: string]: number } = {};
      data.data.symbol.map((s: string, i: number) => {
        stock_market_hash[s] =
          data.data[`시가총액 ${start_date}-${end_date}`][i];
        if (Object.keys(stock_symbol_hash).includes(s)) {
          stock_symbol_hash[s].push(
            data.data[`주가 ${start_date}-${end_date}`][i]
          );
        } else {
          stock_symbol_hash[s] = [
            data.data[`주가 ${start_date}-${end_date}`][i],
          ];
        }
      });
      Object.keys(stock_symbol_hash).forEach((d) => {
        refData[d] = {
          symbol: d,
          stock_price: stock_symbol_hash[d],
          market_cap: stock_market_hash[d],
        };
      });
      return refData;
    } catch (e) {
      console.log(e);
    }
  }
}

export default ReferenceAPIService;
